module.exports = __webpack_public_path__ + "static/media/orders.330a2f5d.jpg";